import loadable from '@loadable/component';
import { Loader } from '@/components';

export const AsyncPromo = loadable(() => import('./Promo'), {
  fallback: <Loader />,
});
